<template lang="html">
  <div class="vx-col w-full">
    <vx-card title="Search Application">
      <template slot="actions">
        <vx-input-group class="">
          <vs-input class="w-full" placeholder="Enter Mobile or NID No"  v-model="searchParam" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-search" @click="serachApplication(searchParam)"></vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>
      <div id="data-list-list-view" class="data-list-container">
        <div v-if="$apollo.loading">
          <div :class="{'activeLoading':activeLoading}" id="loading-default"
               class="vs-con-loading__container loading-example"></div>
        </div>

        <vs-table
          :sst="true"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
          max-items="10000"
          :data="applicationList">
          <template slot="header">
            <!--<h3>
              Reviewed Application List
            </h3>-->
          </template>
          <template slot="thead">
            <vs-th sort-key="email">
              Product Name
            </vs-th>
            <vs-th sort-key="username">
              Suffix
            </vs-th>
            <vs-th sort-key="username">
              Suffix Phone
            </vs-th>
            <vs-th sort-key="website">
              Address
            </vs-th>
            <vs-th sort-key="website">
              Application Status
            </vs-th>
            <vs-th sort-key="id">
              Application Accepted Date
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].product">
                {{data[indextr].product.product}}
              </vs-td>

              <vs-td :data="data[indextr].showroom.suffix">
                {{data[indextr].showroom.suffix}}
              </vs-td>

              <vs-td :data="data[indextr].showroom.suffix">
                {{data[indextr].showroom.phone}}
              </vs-td>

              <vs-td :data="data[indextr].showroom.address">
                {{data[indextr].showroom.address}}
              </vs-td>
              <vs-td :data="data[indextr].status">
                {{data[indextr].status===5?'Accepted':data[indextr].status===7?'Reviewed':''}}
              </vs-td>
              <vs-td :data="data[indextr].accepting_date">
                {{data[indextr].accepting_date}}
              </vs-td>

              <vs-td :data="data[indextr].status">
                <!--<vs-chip :color="getOrderStatusColor(data[indextr].status)" class="product-order-status">
                  {{data[indextr].status =='7'?'Reviewed':'Accepted'}}
                </vs-chip>-->
                <vs-td class="whitespace-no-wrap">
                  <div class="demo-alignment">
                    <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                  class="clickable"/>
                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                  class="ml-2 clickable"/>-->
<!--                    <vs-button color="success" class="mr-3 mt-0" @click="applicationDetal(data[indextr].id)">Reprocess</vs-button>
                    <vs-button color="success" class="mr-3 mt-0" @click="popupActive2=true, updateId=data[indextr].id, invoiceNumber = data[indextr].invoice_number">Update Sales Doc No</vs-button>-->

                  </div>
                </vs-td>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="demo-alignment">
                  <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                class="clickable"/>
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2 clickable"/>-->
                  <!--<feather-icon icon="EyeIcon" @click="applicationDetal(data[indextr].id)"
                                svgClasses="w-5 h-5 hover:text-success stroke-current"
                                class="ml-2 clickable"/>
                  <vx-tooltip text="Download Contract">
                    <feather-icon icon="ArrowDownIcon" @click="downloadAgreement(data[indextr].id)"
                                  svgClasses="w-5 h-5 hover:text-success stroke-current"
                                  class="ml-2 clickable"/>
                  </vx-tooltip>-->
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>
<script>
  import axios from '../axios'

  export default {
    data () {
      return {
        searchParam:'',
        applicationList:[]
      }
    },

    watch: {
      searchApplication (value) {
        console.log('Me = ', value)
        this.applicationList = value;
        this.$apollo.queries.searchApplication.refetch()
      },

    },
    computed: {
      queriedItems () {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      }
    },
    methods: {
      addNewData () {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      deleteData (id) {
        this.$store.dispatch('dataList/removeItem', id).catch(err => {
          console.error(err)
        })
      },
      editData (data) {
        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
        this.sidebarData = data
        this.toggleDataSidebar(true)
      },
      getOrderStatusColor (status) {
        if (status === 7) return 'primary'
        if (status === 5) return 'success'
        if (status === 'canceled') return 'danger'
        return 'primary'
      },
      getPopularityColor (num) {
        if (num > 90) return 'success'
        if (num > 70) return 'primary'
        if (num >= 50) return 'warning'
        if (num < 50) return 'danger'
        return 'primary'
      },
      toggleDataSidebar (val = false) {
        this.addNewDataSidebar = val
      },
      applicationDetal (applicationId) {
        this.$router.push('/applicationDetails/' + applicationId).catch(() => {
        })
      },
      handleSearch (searching) {
        let _print = `The user searched for: ${searching}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleChangePage (page) {
        //let _print = `The user changed the page to: ${page}\n`
        this.selectedPgae = page
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleSort (key, active) {
        let _print = `the user ordered: ${key} ${active}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      serachApplication(data){
        axios.get('https://ho.butterflygroupbd.com/showroom-backend/api/applListForShowroom/'+data).then((response) => {
          console.log("Search", response);
          this.applicationList = response.data.data;
          if(this.applicationList.length === 0){
            this.$vs.notify({
              title: 'Not Found!',
              text: 'No Purchase Information Found.',
              color: "danger",
              position: 'top-right'
            })
          }
          console.log(this.applicationList);
        })
      },
      paddingId(id){
        console.log(id.length);
        if(id.length === 1){return 100000000+id;}
        else if(id.length === 2){return 10000000+id;}
        else if(id.length === 3){return 1000000+id;}
        else if(id.length === 4){return 100000+id;}
        else if(id.length === 5){return 10000+id;}
        else if(id.length === 6){return 1000+id;}
        else if(id.length === 7){return 100+id;}
        else if(id.length === 8){return 10+id;}
        else if(id.length === 9){return 1+id;}
        else if(id.length === 10){return id;}
      },
      downloadAgreement(id){
        this.pdfFile =  "https://showroom.butterflygroupbd.com/showroom-backend/storage/agreement_"+id+".pdf";
        return window.open(this.pdfFile);
      }
    },
    created () {

    },
    mounted () {
      this.isMounted = true
    }
  }
</script>

<style lang="scss">
  .clickable {
    cursor: pointer;
  }

  img.product-img.butterfly-product {
    height: 40px;
    width: auto;
  }

  .vs-table--not-data {
    display: none;
  }

  #data-list-list-view {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              left: 1rem;
            }

            &:focus + i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

          td {
            padding: 20px;

            &:first-child {
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }

            &:last-child {
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }

          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }

        th.td-check {
          padding: 0 15px !important;
        }

        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }


  .fill-row-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    .loading-example {
      width: 120px;
      float: left;
      height: 120px;
      box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      margin: 8px;
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.05);
        transform: translate(0, 4px);
      }

      h4 {
        z-index: 40000;
        position: relative;
        text-align: center;
        padding: 10px;
      }

      &.activeLoading {
        opacity: 0 !important;
        transform: scale(0.5);
      }
    }
  }


</style>
